/**
 * FilterTabs — controlled tab bar for filtering a list/table view
 * (WSRPDM-0011).
 */
import type { ReactNode } from 'react';
import { Tab, Tabs } from '@mui/material';

interface FilterTabItem {
  key: string;
  /**
   * `ReactNode` (widened from `string` in WSRPDM-0013) so a tab can carry a
   * trailing indicator — e.g. an "Unmapped" chip next to a raw-enum label —
   * without a second tab-bar component. Backward-compatible: every existing
   * caller (WSRPDM-0012's Tenants tabs) passes a plain string, which is
   * itself a valid `ReactNode`.
   */
  label: ReactNode;
}

interface FilterTabsProps {
  tabs: FilterTabItem[];
  active: string;
  onChange: (key: string) => void;
  ariaLabel?: string;
}

export function FilterTabs({ tabs, active, onChange, ariaLabel }: FilterTabsProps) {
  return (
    <Tabs
      value={active}
      onChange={(_event, value: string) => onChange(value)}
      aria-label={ariaLabel}
      sx={{ minHeight: 36 }}
    >
      {tabs.map((tab) => (
        <Tab key={tab.key} value={tab.key} label={tab.label} sx={{ minHeight: 36, py: 0.5 }} />
      ))}
    </Tabs>
  );
}
